<template>
  <Modal
    v-model="_value"
    width="500"
    title='ZT触发报警行为'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onSendDriverCardParams">

    <Form :label-width="110">
      <FormItem prop="alarm" label="触发报警行为">
        <Select v-model="alarm" style="width: 220px;">
          <Option v-for="item in alarmOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
    </Form>
<!--    <Button type="primary" @click="onCloseDriverCardParams" style="margin-right: 5px;">关闭报警</Button>-->
    <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
    <Button type="primary" @click="onSendDriverCardParams">发送</Button>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'ztsettriggeralarmmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    businessUserId: null
  },
  data () {
    return {
      // 报警行为选项
      alarm: null,
      alarmOptions: [
        // { name: '车距过近', value: 1 },
        // { name: '抽烟', value: 2 },
        // { name: '打电话', value: 3 },
        // { name: '车道偏离', value: 4 },
        // { name: '前车碰撞', value: 5 },
        // { name: '（左顾右盼）长时间不目视前方', value: 6 },
        { name: '疲劳驾驶', value: 7 },
        // { name: '未检测到驾驶员', value: 8 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'ShortMessageServ_Send'
    ]),

    SendCommand (content) {
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },

    onSendDriverCardParams () {
      let content = '_CoMmAnD@RuN:enable=1 alarm=' + this.alarm + ' speed=30'

      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        let content = '_CoMmAnD@RuN:enable=0 alarm=' + this.alarm + ' speed=30'
        setTimeout(() => {
            this.SendCommand(content)
          }
          , 10000)
        this.$Message.success('发送成功')
      }).catch(err => {
        let content = '_CoMmAnD@RuN:enable=0 alarm=' + this.alarm + ' speed=30'
        setTimeout(() => {
            this.SendCommand(content)
          }
          , 10000)
        this.$Message.error(err)
      })
    },
    onCleanDriverCardParams () {
      this.alarm = null
    },
    // onCloseDriverCardParams () {
    //   let content = '_CoMmAnD@RuN:enable=0 alarm=' + this.alarm + ' speed=30'
    //
    //   store.dispatch('NetCommandServ_SendCommand', {
    //     params: { id: this._initValue, content: content, urgent: false }
    //   }).then(() => {
    //     this.$Message.success('发送成功')
    //   }).catch(err => {
    //     this.$Message.error(err)
    //   })
    // },
    visibleChange (val) {
      if (val) {
        this.alarm = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _businessUserId: {
      get () {
        return this.businessUserId
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules,
        phoneNum: this.phoneNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
